import React from 'react';
import {
   Box,
   Typography,
   Card,
   MenuItem,
   FormControl,
   Select,
   TextareaAutosize,
   Dialog,
   Menu,
   Button,
} from '@mui/material';
import cost from '../../../assets/cost.svg';
import contactImg from '../../../assets/phonebook3.svg';
import { Container } from './style';
import backImg from '../../../assets/back.svg';
import verticalMenu from '../../../assets/verticalMenu.svg';
import scheduleImg from '../../../assets/schMessage.svg';
import styled from '@emotion/styled';
import ScheduleDate from '../../../components/message/scheduleMessage/ScheduleDate';
import MessageContact from '../messageContact';
import MessageSummary from '../../../components/message/messageHome/MessageSummary';
import GroupSelect from '../../../components/message/select/GroupSelect';
import ContactContent from '../message/ContactContent';
import { useDispatch, useSelector } from 'react-redux';
import { messageSelector } from '../../../components/utils/selectors/selectors';
import GroupContent from '../message/GroupContent';
import {
   addSelectedContacts,
   // addSelectedGroups,
   // addSelectedContacts,
   // addSelectedGroups,
   // draftmessage,
   editExistingMessage,
   fetchsenderIDs,
   getMsgCost,
   getSingleMessage,
   resetCreated,
   schedulemessage,
   // sendExistingMessage,
   sendmessage,
   // sendmessage,
} from '../../../components/app/features/message/messageSlice';
import Success from '../message/Success';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

const Textarea = styled(TextareaAutosize)(
   ({ theme }) => `
		width: 100%;
		min-height: 150px;
      padding: 10px;
		border: 1px solid #A1A1A1;
		border-radius:5px;
		font-size:1rem;
      background: white;
      color: #49454F;
		margin-top: 2rem;
      
		&:focus {
      outline: none;
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
    },
     `
);
const DropDown = styled(Menu)(
   ({ theme }) => `
	position: absolute;
	right: 0;

& .MuiPopover-paper {
	border-radius:0;
}
& .MuiList-root, & .MuiMenu-list {
	// padding:0;
	border-radius:0;
}

	`
);
const Activity = styled(MenuItem)(
   ({ theme }) => `
	min-height:unset;
	padding:5px 0;
 box-sizing: border-box;
 white-space: nowrap;
	width: 160px;
	font-weight:600;	
	border-radius:0;
	`
);

const DraftEdit = () => {
   const selector = useSelector(messageSelector);
   const dispatch = useDispatch();
   const [anchorEl, setAnchorEl] = React.useState(null);
   const [period, setPeriod] = React.useState(false);
   const [draftOpen, setDraftOpen] = React.useState(false);
   const [add, setAdd] = React.useState(false);
   const [openSummary, setOpenSummary] = React.useState(false);
   const [selectGroup, setSelectGroup] = React.useState(false);
   const [open, setOpen] = React.useState(false);
   const [action, setAction] = React.useState('');
   const [schedule, setSchedule] = React.useState(false);
   const [scheduleSuccess, setScheduleSuccess] = React.useState(false);
   const [text, setText] = React.useState('');
   const [senderId, setSenderId] = React.useState('');
   const [numOfContacts, setNumOfContacts] = React.useState(0);
   const [groupIds, setGroupIds] = React.useState([]);
   const [contactIds, setContactIds] = React.useState([]);
   const [numbers, setNumbers] = React.useState([]);
   const actions = ['Save to Drafts'];
   const params = useParams();

   const maxCharactersPerPage = 160;
   const calculatePageCount = (text) => {
      return Math.ceil(text.length / maxCharactersPerPage);
   };

   const remainingCharacters =
      maxCharactersPerPage - (text.length % maxCharactersPerPage);

   const handleTextAreaChange = (e) => {
      const { value } = e.target;
      setText(value);
   };

   const handleChange = (event) => {
      setSenderId(event.target.value);
   };

   React.useEffect(() => {
      dispatch(fetchsenderIDs());
      if (selector.message) {
         setText(selector?.message?.content || '');
         setSenderId(selector?.message?.senderId || '');
         if (selector?.message?.contacts)
            dispatch(addSelectedContacts(selector?.message?.contacts));
         if (selector?.message?.groups)
            dispatch(addSelectedContacts(selector?.message?.groups));
      }
      // eslint-disable-next-line
   }, [selector.message]);

   React.useEffect(() => {
      if (selector.sent === true) {
         setOpen(true);
      } else {
         setOpen(false);
      }
      // eslint-disable-next-line
   }, [selector.sent === true]);

   React.useEffect(() => {
      if (selector.scheduled === true) {
         setScheduleSuccess(true);
      } else {
         setScheduleSuccess(false);
      }
   }, [selector.scheduled === true]);

   React.useEffect(() => {
      if (action === 'Save to Drafts') {
         setDraftOpen(true);
      }
      // eslint-disable-next-line
   }, [action === 'Save to Drafts']);

   React.useMemo(() => {
      setGroupIds(selector?.selectedGroups.map((group) => group.id));
      setContactIds(selector?.selectedContacts.map((contact) => contact.id));
      setNumbers(selector?.selectedNumbers);
      // eslint-disable-next-line
   }, [
      selector?.selectedGroups,
      selector?.selectedContacts,
      selector?.selectedNumbers,
   ]);

   const currentDate = dayjs(new Date().toISOString());
   const [date, setDate] = React.useState(currentDate);

   const getTime = (value) => {
      setDate(value);
      setPeriod(false);
   };
   const closePeriod = () => setPeriod(false);
   const draft = () => {
      if (text !== '') {
         dispatch(
            editExistingMessage({
               id: params.id,
               content: text,
               senderId: senderId,
               scheduledAt: currentDate,
               contactids: contactIds,
               groupids: groupIds,
               numbers,
            })
         );
         window.history.back();
      } else {
         toast.info('type a message');
      }
   };
   const handleMenu = (value) => {
      setAction(value);
      setAnchorEl(null);
   };
   const setClose = () => setAnchorEl(false);
   React.useEffect(() => {
      dispatch(getSingleMessage({ id: params.id }));

      // eslint-disable-next-line
   }, [params.id]);

   React.useEffect(() => {
      if (selector.msgCost?.dNDCount > 0 || selector.msgCost?.nonDNDCount > 0) {
         setNumOfContacts(
            selector.msgCost.dNDCount + selector.msgCost.nonDNDCount
         );
      } else {
         setNumOfContacts(0);
      }
   }, [selector.msgCost]);

   console.log(selector?.selectedNumbers);

   React.useMemo(() => {
      dispatch(
         getMsgCost({
            content: text,
            senderId: senderId,
            scheduledAt: date,
            contactids: contactIds,
            groupids: groupIds,
            numbers,
         })
      );
      // eslint-disable-next-line
   }, [selector?.selectedGroups || selector?.selectedContacts]);
   const resetMsgSummary = () => setOpenSummary(false);

   const resendMsg = (values) => {
      dispatch(sendmessage(values));
   };

   const send = (values) => {
      setDate(currentDate);
      if (text !== '' && schedule === false) {
         // console.log(values);
         resendMsg(values);
         setText('');
      } else if (text !== '' && schedule === true) {
         dispatch(schedulemessage(values));
         setText('');
         setSchedule(false);
      } else {
         toast.info('type a message');
      }
   };

   return (
      <Container>
         <Card
            sx={{
               width: '90%',
               maxWidth: '615px',
               minHeight: '80vh',
               margin: '0 auto',
               marginTop: '2rem',
               position: 'relative',
               boxShadow:
                  '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
               padding: '20px ',
               background: '#E8E8E8',
            }}
         >
            <Box
               sx={{
                  margin: '0 auto',
                  marginTop: '1rem',
                  border: '1px solid transparent',
                  position: 'relative',
               }}
            >
               <img
                  src={backImg}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '40px',
                     cursor: 'pointer',
                     // border: '1px solid',
                  }}
                  onClick={() => {
                     if (text !== '') {
                        setDraftOpen(true);
                     } else {
                        window.history.back();
                     }
                  }}
               />
               <DropDown
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={setClose}
                  MenuListProps={{
                     'aria-labelledby': 'basic-button',
                  }}
               >
                  {actions.map((action, index) => (
                     <Activity
                        key={index}
                        onClick={(e) => handleMenu(e.target.innerText)}
                     >
                        {action}
                     </Activity>
                  ))}
               </DropDown>
               <img
                  src={verticalMenu}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '40px',
                     right: 0,
                     filter:
                        'invert(27%) sepia(11%) saturate(7243%) hue-rotate(207deg) brightness(94%) contrast(88%)',
                     cursor: 'pointer',
                  }}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
               />
               <Typography
                  sx={{
                     width: 'max-content',
                     margin: '0 auto',
                     color: '#0F0E0E',
                     fontWeight: 600,
                     fontSize: 'clamp(1.1rem, 2vw, 1.25rem)',
                     marginTop: '3rem',
                  }}
               >
                  Send Message
               </Typography>
               <Typography
                  sx={{
                     margin: '1.5rem 0 0.5rem 0',
                     fontWeight: 600,
                     fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
                     color: '#0F0E0E',
                  }}
               >
                  Sender Id
               </Typography>
               <FormControl fullWidth>
                  <Select
                     id="demo-simple-select"
                     value={senderId}
                     onChange={handleChange}
                     sx={{
                        backgroundColor: '#fff',
                        fontWeight: 600,
                        padding: '25px 0 !important',
                        fontFamily: "'Raleway', 'Montserrat', sans-serif",
                        '& .MuiOutlinedInput-notchedOutline': {
                           borderColor: '#A1A1A1', // change this to the desired color
                        },
                     }}
                  >
                     {selector?.senderIds ? (
                        selector?.senderIds
                           .filter((x) => x.status == 'approved')
                           .map((senderId, index) => (
                              <MenuItem value={senderId?.senderId} key={index}>
                                 {senderId?.senderId}
                              </MenuItem>
                           ))
                     ) : (
                        <MenuItem value={1}>No Sender Ids</MenuItem>
                     )}
                  </Select>
               </FormControl>
               <Typography
                  sx={{
                     margin: '1.5rem 0 0.5rem 0',
                     fontWeight: 600,
                     fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
                     color: '#0F0E0E',
                     fontFamily: "'Raleway', 'Montserrat', sans-serif",
                  }}
               >
                  Recipients
               </Typography>
               <Box sx={{ position: 'relative' }}>
                  <img
                     src={contactImg}
                     alt="icon"
                     style={{
                        width: '30px',
                        position: 'absolute',
                        zIndex: 10,
                        right: '10px',
                        bottom: '50%',
                        transform: 'translateY(50%)',
                        cursor: 'pointer',
                     }}
                     onClick={() => setAdd(true)}
                  />

                  <Box
                     sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignContent: 'flex-start',
                        bgcolor: 'background.paper',
                        maxHeight: 100,
                        border: '1px solid #A1A1A1',
                        minHeight: '60px',
                        background: '#fff',
                        borderRadius: '5px',
                        padding: '10px',
                        paddingRight: '40px',
                        overflow: 'auto',
                        width: '100%',
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'grey',
                        // '&::-webkit-scrollbar': {
                        //    width: 0,
                        //    height: 0,
                        // },
                     }}
                  >
                     {selector.selectedGroups.length > 0
                        ? selector.selectedGroups.map((item, id) => (
                             <GroupContent key={id} item={item} />
                          ))
                        : null}
                     {selector.selectedContacts.length > 0
                        ? selector.selectedContacts.map((item, id) => (
                             <ContactContent key={id} item={item} />
                          ))
                        : null}

                     {selector.selectedNumbers.length > 0
                        ? selector.selectedNumbers.map((item, id) => (
                             <ContactContent key={id} item={{ number: item }} />
                          ))
                        : null}
                  </Box>
               </Box>
               <Typography
                  sx={{
                     margin: '1rem 0',
                     display: 'flex',
                     fontWeight: 600,
                     color: '#374da0',
                     cursor: 'pointer',
                     width: 'max-content',
                  }}
                  onClick={() => {
                     dispatch(
                        getMsgCost({
                           content: text,
                           senderId: senderId,
                           scheduledAt: date,
                           contactids: contactIds,
                           groupids: groupIds,
                           numbers,
                        })
                     );
                     setOpenSummary(true);
                  }}
               >
                  <img src={cost} alt="icon" style={{ marginRight: '10px' }} />
                  View Pricing Info
               </Typography>
               <Textarea
                  margin="normal"
                  name="desc"
                  aria-label="about"
                  minRows={1}
                  onChange={handleTextAreaChange}
                  value={text}
                  variant="outlined"
                  id="group_desc"
               />
               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     marginBottom: '2rem',
                  }}
               >
                  <Typography
                     sx={{
                        width: 'max-content',
                        color: '#374DAO',
                        fontWeight: '600',
                     }}
                  >
                     {remainingCharacters}/{calculatePageCount(text)}
                  </Typography>
                  <Typography
                     sx={{
                        width: 'max-content',
                        color: '#374DAO',
                        fontWeight: '600',
                     }}
                  >
                     {`	contacts: `}
                     {numOfContacts}
                  </Typography>
               </Box>
               <Button
                  disabled={text.length === 0}
                  sx={{
                     width: '300px',
                     margin: '1.5rem auto',
                     borderRadius: '8px',
                     backgroundColor: '#374DA0',
                     color: '#fff',
                     display: 'flex',
                     justifyContent: 'space-between',
                     ':hover': {
                        backgroundColor: '#374DA0',
                     },
                     '@media(max-width:500px)': {
                        width: '100%',
                     },
                  }}
               >
                  <Typography
                     sx={{
                        textAlign: 'center',
                        width: '80%',
                        padding: '10px',
                        cursor: 'pointer',
                     }}
                     onClick={() => {
                        send({
                           content: text,
                           senderId: senderId,
                           scheduledAt: date,
                           contactids: contactIds,
                           groupids: groupIds,
                           numbers,
                        });
                     }}
                  >
                     Send Message
                  </Typography>
                  <Typography
                     sx={{
                        width: '20%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderLeft: '1px solid #fff',
                        padding: '10px',
                        cursor: 'pointer',
                     }}
                     onClick={() => {
                        setPeriod(true);
                        setSchedule(true);
                     }}
                  >
                     <img src={scheduleImg} alt="icon" />
                  </Typography>
               </Button>
               <Dialog onClose={() => setPeriod(false)} open={period}>
                  <ScheduleDate getTime={getTime} closePeriod={closePeriod} />
               </Dialog>
               <Dialog
                  onClose={() => {
                     setAction('');
                     setDraftOpen(false);
                  }}
                  open={draftOpen}
               >
                  <Card sx={{ padding: '20px 55px' }}>
                     <Typography
                        sx={{
                           textAlign: 'center',
                           marginBottom: '2rem',
                           fontWeight: 600,
                           fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                        }}
                     >
                        Save this update?
                     </Typography>
                     <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography
                           sx={{
                              fontWeight: 600,
                              fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                              color: '#374DAO',
                              marginRight: '1rem',
                              cursor: 'pointer',
                           }}
                           onClick={() => draft()}
                        >
                           Save
                        </Typography>
                        <Typography
                           sx={{
                              fontWeight: 600,
                              fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                              color: '#374DAO',
                              cursor: 'pointer',
                           }}
                           onClick={() => window.history.back()}
                        >
                           Discard
                        </Typography>
                     </Box>
                  </Card>
               </Dialog>
               <Dialog onClose={() => setAdd(false)} open={add}>
                  <MessageContact
                     contactText={'/send-message/select-contact'}
                     groupsText={'/send-message/select-group'}
                     pasteText={'/send-message/select-paste'}
                  />
               </Dialog>
               <Dialog onClose={() => setSelectGroup(false)} open={selectGroup}>
                  <GroupSelect />
               </Dialog>
               <Dialog onClose={() => setOpenSummary(false)} open={openSummary}>
                  <MessageSummary resetMsgSummary={resetMsgSummary} />
               </Dialog>
               <Dialog
                  onClose={() => {
                     dispatch(resetCreated());
                     setOpen(false);
                  }}
                  open={open}
               >
                  <Success msgType="Message Sent!" />
               </Dialog>
               <Dialog
                  onClose={() => setScheduleSuccess(false)}
                  open={scheduleSuccess}
               >
                  <Success msgType="Message Scheduled Successfully!" />
               </Dialog>
            </Box>
         </Card>
      </Container>
   );
};

export default DraftEdit;
